import React from "react";
import { useNavigate } from "react-router-dom";
import "./PreLicenseProgram.css";

const PreLicenseProgram = () => {
  const navigate = useNavigate();

  return (
    <div className="program-container">
      <h2 className="title">
        Girls’ Pre-Licensing Driver Training Program <br />
        <span className="subtitle">(LMV Girls Applicants)</span>
      </h2>

      <p className="description">
        RDTC Singawal, under the CSR initiative of Shri Ram Sewa Sankalp and D.B. Skill,
        launched a Pre-Licensing Driver Training Program for Girls to promote women’s 
        empowerment and mobility. 60 girls mobilized in two batches for LMV (Light Motor
        Vehicle) licensing. Training combines classroom, simulator, and on-road practice 
        with focus on gender-sensitive instruction, flexible timings, and placement support.
      </p>

      <div className="content-box">
        <div className="left-content">
          <h3>Program Details:</h3>
          <ul>
            <li>132 hours of theoretical training</li>
            <li>64 hours of on-road training</li>
            <li>Duration: 45 days</li>
            <li>Simulator-based driving sessions</li>
            <li>Practical on-road driving experience</li>
            <li>
              Eligible participants are awarded LMV Licenses upon successful
              completion and meeting standards
            </li>
          </ul>
        </div>

        <div className="right-content">
          <img
            className="program-image"
            src="images/_classroom_photo.png"
            alt="LMV Girl Training"
          />
        </div>
      </div>

      <div className="button-container">
        <button className="back-button" onClick={() => navigate("/")}>
          Back to Home
        </button>
      </div>
    </div>
  );
};

export default PreLicenseProgram;
